import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";

import { HANDBOOK_INITIAL_LOAD_COUNT } from "../const";
import { getHandbookTemplateSections, getHandbookTemplates } from "../model/thunks";
import { useTypedSelector } from "app/store/typedUseSelector";

import { findSegmentsById } from "../utils/segments";
import { generateStorageKey } from "utils/helpers/generateStorageKey";

export const useCurrentTemplateStructure = ({
  templateId,
  sectionId,
  subSectionId,
  segmentId,
}: {
  templateId?: string;
  sectionId?: string;
  subSectionId?: string;
  segmentId?: string | null;
}) => {
  const dispatch = useDispatch();
  // @ts-ignore | Ключ всех шаблонов – пустой фильтр. Не будет находить шаблон, если был переход по прямой ссылке
  const templates = useTypedSelector((state) => state.handBookReducer.templates)[generateStorageKey({})];
  const sections = useTypedSelector((state) => state.handBookReducer.templateSections)[
    // @ts-ignore | Секции выбранного шаблона
    generateStorageKey({ template_id: templateId })
  ];
  const allSegments = useTypedSelector((state) => state.handBookReducer.allSegments);
  const { currentTemplate, currentSection, currentSubSection } = useMemo(() => {
    const currentTemplate = templateId ? templates?.results?.find((t) => +t.id === +templateId) : null;
    const currentSection = sectionId ? sections?.results?.find((s) => +s.id === +sectionId) : null;
    const currentSubSection = subSectionId ? currentSection?.children?.find((s) => +s.id === +subSectionId) : null;
    return { currentTemplate, currentSection, currentSubSection };
  }, [subSectionId, sectionId, templateId, sections, templates]);

  const { segment, parentSegment } = useMemo(() => {
    if (!segmentId) return {};
    const { segment, parentSegment } = findSegmentsById(allSegments, Number(segmentId));
    return { segment, parentSegment };
  }, [segmentId, allSegments]);

  useEffect(() => {
    if (!templates?.results?.length) {
      dispatch(getHandbookTemplates({ limit: HANDBOOK_INITIAL_LOAD_COUNT }));
    }
    if (!sections?.results?.length && templateId) {
      dispatch(
        getHandbookTemplateSections({
          template_id: templateId,
          limit: HANDBOOK_INITIAL_LOAD_COUNT,
        })
      );
    }
  }, [templates, sections, templateId]);

  return { currentTemplate, currentSection, currentSubSection, segment, parentSegment };
};
